export default [
  {
    icon: <div className="menuImage"></div>,
    key: 'platform', //配置成子应用对应的name
    name: '平台管理',
    path: '/platform',
    appPath: '/platform',
    sortNumber: 22,
    sysVisibleFlag: 1,
    type: 'sys',
    children: [
      {
        key: 'notify',
        name: '租户管理',
        path: '/lessee',
        appPath: '/platform',
        sortNumber: 0,
        sysVisibleFlag: 1,
        type: 'menu',
        level: 2,
      },
    ],
    level: 1,
  },
  {
    icon: <div className="menuImage"></div>,
    key: 'platform', //配置成子应用对应的name
    name: '权限管理',
    path: '/platform',
    appPath: '/platform',
    sortNumber: 23,
    sysVisibleFlag: 1,
    type: 'sys',
    children: [
      {
        key: 'clientMobileManager',
        name: '开放平台客户端配置',
        path: '/clientMobileManager',
        appPath: '/platform',
        sortNumber: 0,
        sysVisibleFlag: 1,
        type: 'menu',
        level: 2,
      },
    ],
    level: 1,
  },
  {
    icon: <div className="menuImage"></div>,
    key: 'platform', //配置成子应用对应的name
    name: '日志管理',
    path: '/console',
    appPath: '/platform',
    sortNumber: 22,
    sysVisibleFlag: 1,
    type: 'sys',
    children: [
      {
        key: 'notify',
        name: '华为LTS',
        path: '/console/lts',
        appPath: '/platform',
        sortNumber: 0,
        sysVisibleFlag: 1,
        type: 'menu',
        level: 2,
      },
      {
        key: 'notify',
        name: '华为CCE-LTS',
        path: '/console/cce',
        appPath: '/platform',
        sortNumber: 0,
        sysVisibleFlag: 1,
        type: 'menu',
        level: 2,
      },
    ],
    level: 1,
  },
]
